import TopMenu from '../../components/TopMenu/TopMenu.vue'
import Footer from '../../components/Footer/Footer.vue'

export default {
  data: function() {
    return {
      name: '',
      email: '',
      message: '',
      nope: 'nope',
      language: this.$store.getters.language,
      supportedLanguages: this.$store.getters.supportedLanguages
    }
  },
  methods: {
    submitForm: function () {
      const _self = this;
      let nameEmpty = 'Please enter your name';
      let emailInvalid = 'Please enter a valid e-mail';
      let messageEmpty = 'Please enter your message';
      let sendingMessage = 'Sending ...';

      switch(_self.language.value) {
        case 'nl':
          nameEmpty = 'Vul uw naam in aub';
          emailInvalid = 'Geef een geldig e-mail adres op aub';
          messageEmpty = 'Vul uw bericht in aub';
          sendingMessage = 'Versturen ...';
          break;
      }

      if (_self.nope !== 'nope') {
        alert('OK');
        return false;
      }

      if (_self.name === '') {
        alert(nameEmpty);
        return false;
      }

      if (_self.email === '') {
        alert(emailInvalid);
        return false;
      }

      if (_self.message === '') {
        alert(messageEmpty);
        return false;
      }

      let formSubmitButton = $('.ui.form').find('button');
      formSubmitButton.addClass('disabled');
      formSubmitButton.text(sendingMessage);

      $.post({
        url: 'https://sade.qsds.be/api/v1/contact',
        data: {
          name: _self.name,
          email: _self.email,
          message: _self.nl2br(_self.message, true)
        },
        complete: function (jqXHR, textStatus) {
          let successMessage = 'Thank you for getting in touch with us.<br/><br/>Your message has been forwarded to us and we will contact you as soon as possible.';

          switch (_self.language.value) {
            case 'nl':
              successMessage = 'Bedankt dat je contact met ons opneemt.<br/><br/>Uw bericht werd naar ons doorgestuurd en we nemen zo spoedig mogelijk contact met u op.';
              break;
          }

          $('.ui.form').html('<div class="result">' + successMessage + '</div>');
        }
      });
    },
    nl2br: function(str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }

      const breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? "<br/>" : "<br>";
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
  },
  computed: {
    title: function() {
      let title = 'Contact us'

      switch(this.language.value) {
        case 'nl':
          title = 'Contacteer ons'
          break
      }

      return title
    },
    contactForm: function() {
      let title = 'Contact form'
      let description = 'Fill out the form below and we\'ll get in touch as soon as possible.'
      let name = 'Name'
      let email = 'E-mail'
      let msg = 'Message'
      let submitLabel = 'Send message'

      switch(this.language.value) {
        case 'nl':
          title = 'Contact formulier'
          description = 'Vul het onderstaande formulier in en we nemen zo snel mogelijk contact met u op.'
          name = 'Naam'
          email = 'E-mail'
          msg = 'Bericht'
          submitLabel = 'Verstuur bericht'
          break
      }

      return {
        title: title,
        description: description,
        name: name,
        email: email,
        msg: msg,
        submitLabel: submitLabel
      }
    }
  },
  components: {
    'TopMenu': TopMenu,
    'Footer': Footer
  },
  beforeMount() {
    const path = this.$route.path.split('/')
    let language = {
      text: '',
      value: ''
    }

    if (path.length > 0) {
      switch (path[1]) {
        case 'nl':
        case 'en':
          language.value = path[1]
          break
        default:
          if (language.value === '') {
            language.value = 'en'
          }
      }
    }

    switch (language.value) {
      case 'nl':
        language.text = 'Nederlands'
        break
      case 'en':
        language.text = 'English'
        break
    }

    this.$store.commit("language", language)
  },
  mounted() {
    let nameEmpty = 'Please enter your name';
    let emailInvalid = 'Please enter a valid e-mail';
    let messageEmpty = 'Please enter your message';

    switch(this.language.value) {
      case 'nl':
        nameEmpty = 'Vul uw naam in aub';
        emailInvalid = 'Geef een geldig e-mail adres op aub';
        messageEmpty = 'Vul uw bericht in aub';
        break;
    }

    $('.ui.form')
      .form({
        on: 'blur',
        inline: true,
        fields: {
          name : {
            identifier: 'name',
            rules: [
              {
                type   : 'empty',
                prompt : nameEmpty
              }
            ]
          },
          email : {
            identifier  : 'email',
            rules: [
              {
                type   : 'email',
                prompt : emailInvalid
              }
            ]
          },
          msg : {
            identifier: 'msg',
            rules: [
              {
                type   : 'empty',
                prompt : messageEmpty
              }
            ]
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/page/contact/contact.js